import classnames from 'classnames';

const CLASSNAME_MODIFIER_SEPARATOR = '--';

export const buildClassNames = (props, ...others) => classnames(...others, props).trim();

const concatStrings = (s1, ...s2) => s1.concat(...s2);

export const buildClassNameModifiers = (blockClassName, ...modifiers) => modifiers
  .filter(modifier => !(modifier == null))
  .filter(modifier => (typeof modifier === 'object' ? modifier[Object.keys(modifier)[0]] : modifier))
  .map(modifier => concatStrings(blockClassName, CLASSNAME_MODIFIER_SEPARATOR, typeof modifier === 'object' ? Object.keys(modifier)[0] : modifier));


export const wrapComponentName = WrappedComponent => WrappedComponent.displayName || WrappedComponent.name || 'Component';

export const containsOrMatchesElement = (element, values) => {
  if (Array.isArray(values)) {
    return values.indexOf(element) >= 0;
  }
  return element === values;
};

export const capitalize = string => `${string.charAt(0).toUpperCase()}${string.slice(1)}`;

export const px = n => (typeof n === 'number' ? `${n}px` : n);

/** Takes a number and clamps it to the specified range while wrapping the value.
 *  For example:
 *     - `clampAndWrap(0)(3)(5)` returns `1`
 *     - `clampAndWrap(0)(3)(-1)` returns `3`
 */
export const clampAndWrap = min => max => num =>
  ((((num - min) % ((max + 1) - min)) + ((max + 1) - min)) % ((max + 1) - min)) + min;

/**
 * Toggles scrolling on the document body.
 * @param {boolean} enabled
 */
export const toggleBodyScrolling = (enabled) => {
  if (typeof window !== 'undefined') {
    if (enabled) {
      document.body.style.overflow = '';
      document.body.style.marginRight = '';
    } else {
      document.body.style.marginRight = px(window.innerWidth - document.body.clientWidth);
      document.body.style.overflow = 'hidden';
    }
  }
};
